import { GoogleMapMarker } from '@saasalerts/ui'
import { Event } from '@/components/Graphs/types'
import { get, isEmpty } from 'lodash'

export const mapEventsToMarkers = (events: Event[] | undefined) => {
  const _events = events?.filter((event) => !isEmpty(event?.location?.ll))
  const colorObj = {
    critical: 'red',
    medium: 'orange',
    low: 'green',
  }

  const getMarker = (event: Event) => {
    return {
      id: event.id,
      ll: [event.location?.ll?.[1], event.location?.ll?.[0]],
      color: get(colorObj, event.alertStatus),
    }
  }

  // list by color and filter
  const markersList = [
    _events?.filter((event) => event.alertStatus === 'critical').map(getMarker),
    _events?.filter((event) => event.alertStatus === 'medium').map(getMarker),
    _events?.filter((event) => event.alertStatus === 'low').map(getMarker),
  ].filter((e) => e?.length) as GoogleMapMarker[][]

  return markersList
}
